import { render, staticRenderFns } from "./DeliveryTab.vue?vue&type=template&id=51b1fe98&"
import script from "./DeliveryTab.vue?vue&type=script&lang=js&"
export * from "./DeliveryTab.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryTab.vue?vue&type=style&index=0&id=51b1fe98&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports